const CTASection = () => {
  return (
    <section className="py-12 md:py-16 bg-navy-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-cream-100 mb-3 md:mb-5">
            Hemen İletişime Geçin
          </h2>
          <p className="text-cream-300 text-sm md:text-lg mb-6 md:mb-8 max-w-2xl mx-auto">
            İzmir vize danışmanlığı hizmetlerimiz hakkında detaylı bilgi almak ve başvurunuzu başlatmak için bize ulaşın
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-4">
            <a
              href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center px-5 py-2.5 md:px-7 md:py-3 bg-green-600 text-white rounded-full font-semibold text-sm md:text-base hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-lg md:text-xl mr-2"></i>
              WhatsApp ile İletişim
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </a>

            <a
              href="tel:+905514803007"
              className="group inline-flex items-center px-5 py-2.5 md:px-7 md:py-3 bg-cream-400 text-navy-900 rounded-full font-semibold text-sm md:text-base hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-lg md:text-xl mr-2"></i>
              Hemen Ara
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>

          {/* Contact Info */}
          <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-cream-400 rounded-xl md:rounded-2xl mx-auto mb-3 md:mb-4">
                <i className="ri-phone-fill text-2xl md:text-3xl text-navy-900"></i>
              </div>
              <h3 className="font-semibold text-cream-100 mb-1 md:mb-2 text-sm md:text-base">Telefon</h3>
              <a href="tel:+905514803007" className="text-cream-300 hover:text-cream-100 transition-colors cursor-pointer text-xs md:text-sm">
                +90 551 480 3007
              </a>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-cream-400 rounded-xl md:rounded-2xl mx-auto mb-3 md:mb-4">
                <i className="ri-mail-fill text-2xl md:text-3xl text-navy-900"></i>
              </div>
              <h3 className="font-semibold text-cream-100 mb-1 md:mb-2 text-sm md:text-base">E-posta</h3>
              <a href="mailto:karsiyakavisaconsulting@gmail.com" className="text-cream-300 hover:text-cream-100 transition-colors cursor-pointer text-xs md:text-sm break-all">
                karsiyakavisaconsulting@gmail.com
              </a>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-cream-400 rounded-xl md:rounded-2xl mx-auto mb-3 md:mb-4">
                <i className="ri-map-pin-fill text-2xl md:text-3xl text-navy-900"></i>
              </div>
              <h3 className="font-semibold text-cream-100 mb-1 md:mb-2 text-sm md:text-base">Adres</h3>
              <p className="text-cream-300 text-xs md:text-sm">
                Tuna Mah. Kemalpaşa Cad. Kat:5/506<br />
                Ses İş Hanı Karşıyaka / İzmir
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;